import axios from 'axios'

const BASE_URL = `${process.env.VUE_APP_baseUrl}/api/manifests`

export default {
  namespaced: true,

  state: {
    manifests: [],
    manifest: null,
    availableOrders: [],
    outsourcingCompanies: [],
    pagination: {
      count: 0,
      next: null,
      previous: null,
    },
    isLoading: false,
    error: null,
  },

  mutations: {
    SET_MANIFESTS(state, {
      results, count, next, previous,
    }) {
      state.manifests = results
      state.pagination = { count, next, previous }
    },
    SET_MANIFEST(state, manifest) {
      state.manifest = manifest
    },
    SET_AVAILABLE_ORDERS(state, {
      results, count, next, previous,
    }) {
      state.availableOrders = results
      state.pagination = { count, next, previous }
    },
    SET_OUTSOURCING_COMPANIES(state, companies) {
      state.outsourcingCompanies = companies
    },
    SET_LOADING(state, val) {
      state.isLoading = val
    },
    SET_ERROR(state, err) {
      state.error = err
    },
  },

  actions: {
    async fetchManifests({ commit }, params = {}) {
      commit('SET_LOADING', true)
      try {
        const { data } = await axios.get(`${BASE_URL}/`, { params })
        commit('SET_MANIFESTS', {
          results: data.results || data,
          count: data.count || 0,
          next: data.next || null,
          previous: data.previous || null,
        })
      } catch (err) {
        commit('SET_ERROR', err)
        throw err
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async fetchManifest({ commit }, id) {
      commit('SET_LOADING', true)
      try {
        const { data } = await axios.get(`${BASE_URL}/${id}/`)
        commit('SET_MANIFEST', data)
        return data
      } catch (err) {
        commit('SET_ERROR', err)
        throw err
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async createManifest(_, payload) {
      const { data } = await axios.post(`${BASE_URL}/create/`, payload)
      return data
    },

    async addOrders({ commit }, { manifestId, orderIds }) {
      const { data } = await axios.post(`${BASE_URL}/${manifestId}/add-orders/`, {
        order_ids: orderIds,
      })
      commit('SET_MANIFEST', data.manifest)
      return data
    },

    async removeOrders(_, { manifestId, orderIds }) {
      const { data } = await axios.post(`${BASE_URL}/${manifestId}/remove-orders/`, {
        order_ids: orderIds,
      })
      return data
    },

    async fetchAvailableOrders({ commit }, params = {}) {
      commit('SET_LOADING', true)
      try {
        const { data } = await axios.get(`${BASE_URL}/available-orders/`, { params })
        commit('SET_AVAILABLE_ORDERS', {
          results: data.results || data,
          count: data.count || 0,
          next: data.next || null,
          previous: data.previous || null,
        })
      } catch (err) {
        commit('SET_ERROR', err)
        throw err
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async fetchOutsourcingCompanies({ commit }) {
      const { data } = await axios.get(`${BASE_URL}/outsourcing-companies/`)
      commit('SET_OUTSOURCING_COMPANIES', data)
      return data
    },
  },

  getters: {
    manifests: s => s.manifests,
    manifest: s => s.manifest,
    availableOrders: s => s.availableOrders,
    outsourcingCompanies: s => s.outsourcingCompanies,
    isLoading: s => s.isLoading,
    pagination: s => s.pagination,
  },
}
